var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgQuotes(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 251,
    height: 140,
    viewBox: "0 0 251 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.1331 27.28L29.5331 31.44C28.3065 31.3333 27.3331 31.5467 26.6131 32.08C25.8931 32.5867 25.3998 33.32 25.1331 34.28C24.8931 35.2133 24.8531 36.28 25.0131 37.48H30.1331V47.76H20.2531V37.08C20.2531 33.5867 21.0798 30.9467 22.7331 29.16C24.3865 27.3467 26.8531 26.72 30.1331 27.28ZM16.7331 27.28L16.1331 31.44C14.9065 31.3333 13.9331 31.5467 13.2131 32.08C12.4931 32.5867 11.9998 33.32 11.7331 34.28C11.4931 35.2133 11.4531 36.28 11.6131 37.48H16.7331V47.76H6.85313V37.08C6.85313 33.5867 7.67979 30.9467 9.33313 29.16C10.9865 27.3467 13.4531 26.72 16.7331 27.28Z",
    fill: "white",
    fillOpacity: 0.7
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M220.853 78.72L221.413 74.56C222.64 74.6667 223.613 74.4667 224.333 73.96C225.053 73.4267 225.533 72.6933 225.773 71.76C226.04 70.8 226.106 69.72 225.973 68.52H220.853V58.24H230.733V68.92C230.733 72.4133 229.906 75.0533 228.253 76.84C226.6 78.6267 224.133 79.2533 220.853 78.72ZM234.253 78.72L234.813 74.56C236.04 74.6667 237.013 74.4667 237.733 73.96C238.453 73.4267 238.933 72.6933 239.173 71.76C239.44 70.8 239.506 69.72 239.373 68.52H234.253V58.24H244.133V68.92C244.133 72.4133 243.306 75.0533 241.653 76.84C240 78.6267 237.533 79.2533 234.253 78.72Z",
    fill: "white",
    fillOpacity: 0.7
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuotes);
export default __webpack_public_path__ + "static/media/quotes.43c6600410e602455c6a073ac78dd201.svg";
export { ForwardRef as ReactComponent };